'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = highlightText;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Zvýrazní text v řetězci.
 * @param search text pro zvýraznění
 * @param text řetězec
 * @return {*}
 */
function highlightText(search, text) {
    if (!search) {
        return text;
    }
    var searchLen = search.length;
    if (searchLen === 0) {
        return text;
    }

    var textLower = text.toLocaleLowerCase();
    var searchLower = search.toLocaleLowerCase();

    var arr = textLower.split(searchLower);
    var result = [];

    var i = 0;
    for (var a = 0; a < arr.length; a++) {
        var partLen = arr[a].length;
        if (partLen > 0) {
            result.push(text.substring(i, i + partLen));
            i += partLen;
        }
        result.push(_react2.default.createElement(
            'strong',
            null,
            text.substring(i, i + searchLen)
        ));
        i += searchLen;
    }

    return result;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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